module.exports = __webpack_public_path__ + "static/img/img-invertir.47b1717.jpg";